import { api } from './../../api.js';
import { config } from './../../config.js';

const actions = {
    BACK_ABONADOS_CREATE : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.abonados.create'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_ABONADOS_ASIENTO : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.abonados.asiento'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_ABONADOS_SANCIONAR : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.abonados.sancionar'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_ABONADOS_SANCION_BORRAR : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.abonados.sancion.borrar'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_ABONADOS_RENOVAR : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.abonados.renovar'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_ABONADOS_ANULAR : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.abonados.anular'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_ABONADOS_BORRAR : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.abonados.borrar'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_ABONADOS_ABONO_ENVIAR : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.abonados.abono.enviar'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_ABONADOS_ABONOS_DESCARGAR_EXCEL : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.abonados.abonos.descargar_excel'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_ABONADOS_ENVIAR : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.abonados.enviar'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_ENVIOS_INDEX : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.envios.index'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_ENVIOS_TIPO_ABONO : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.envios.tipo.abono'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_ENVIOS_ENVIAR : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.envios.enviar'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_ENVIOS_SHOW : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.envios.show'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_ENVIOS_DESCARGAR_EXCEL : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.envios.descargar_excel'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_ABONADOS_ALTA : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.abonados.alta'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_ABONADOS_INDEX : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.abonados.index'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_ABONADOS_METODOS_PAGO : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.abonados.metodos-pago'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_ABONADOS_TIPOS_ABONOS : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.abonados.tipos.abonos'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_ABONADOS_SHOW : function({ commit },data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.abonados.show'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_ABONADOS_EDITAR : function({ commit },data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.abonados.editar'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_ABONADOS_METODOPAGO_EDITAR : function({ commit },data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.abonados.metodopago.editar'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_ABONADOS_TIPOABONO_EDITAR : function({ commit },data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.abonados.tipoabono.editar'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_ABONADOS_PLAZOS_PAGAR : function({ commit },data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.abonados.plazos.pagar'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_ABONADOS_PLAZOS_PAGAR_TODOS : function({ commit },data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.abonados.plazos.pagar-todos'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_ABONADOS_PLAZOS_ANULAR : function({ commit },data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.abonados.plazos.anular'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_ABONADOS_PLAZOS_DESCONTAR : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.abonados.plazos.descontar'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_ABONADOS_PLAZOS_ENVIAR_URL_COMPRA : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.abonados.plazos.enviar-url-compra'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_ABONADOS_BORRAR_DOCUMENTO_SUBIDO_ABONADO : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.abonados.borrar.documento'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_ABONADOS_EDITAR_DOCUMENTO_SUBIDO_ABONADO : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.abonados.editar.documento'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_ABONADOS_TRANSACCIONES_EDITAR : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.abonados.transacciones.editar'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_ABONADOS_ASIENTOS_LIBERADOS_RECUPERAR : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.abonados.asientos_liberados.recuperar'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_ABONADOS_ABONADO_IMPRESOS : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.abonados.abonado.impresion'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        })
    },
    BACK_ABONADOS_MONEDERO : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.abonados.monedero'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        })
    },

    BACK_ABONADOS_MONEDERO_ADD : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.abonados.monedero.add'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        })
    },

    BACK_ABONADOS_EVENTOS : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.abonados.eventos'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        })
    },

    BACK_ABONADOS_LIBERAR_ASIENTOS : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.abonados.liberar.asientos'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        })
    },
    BACK_ABONADOS_ABONO_MODIFICAR_ESTADO : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.abonados.abono.modificar-estado'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_ABONADOS_GUARDAR_DATOS_COMPRADOR : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.abonados.guardar-datos-comprador'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_ABONADOS_ABONO_LISTADO_INVITACIONES_EVENTOS: function({ commit }, data){
        return new Promise((resolve, reject) =>{
            api.call(config.getAPIRoute('back.abonados.abono.listado-invitaciones-eventos'), data).then(res =>{
                resolve(res);
            }).catch(error =>{
                console.log(error);
                reject(error);
            });
        })
    },
    BACK_ABONADOS_ABONO_LISTADO_INVITACIONES_CONSUMIDAS: function({ commit }, data) {
        return new Promise((resolve, reject) =>{
            api.call(config.getAPIRoute('back.abonados.abono.listado-invitaciones-consumidas'), data).then(res =>{
                resolve(res);
            }).catch(error =>{
                console.log(error);
                reject(error);
            });
        })
    },
    BACK_ABONADOS_ABONO_INVITACIONES_ZONAS: function({ commit }, data) {
        return new Promise((resolve, reject) =>{
            api.call(config.getAPIRoute('back.abonados.abono.invitaciones-zonas'), data).then(res =>{
                resolve(res);
            }).catch(error =>{
                console.log(error);
                reject(error);
            });
        })
    },
    BACK_ABONADOS_ABONO_INVITACIONES_ASIENTOS: function({ commit }, data) {
        return new Promise((resolve, reject) =>{
            api.call(config.getAPIRoute('back.abonados.abono.invitaciones.asientos'), data).then(res =>{
                resolve(res);
            }).catch(error =>{
                console.log(error);
                reject(error);
            });
        })
    },
    BACK_ABONADOS_ABONO_INVITACIONES_BLOQUEAR_ASIENTOS: function({ commit }, data) {
        return new Promise((resolve, reject) =>{
            api.call(config.getAPIRoute('back.abonados.abono.invitaciones.bloquear-asientos'), data).then(res =>{
                resolve(res);
            }).catch(error =>{
                console.log(error);
                reject(error);
            });
        })
    },

    BACK_ABONADOS_INVITACIONES_GUARDAR_DATOS_COMPRADOR: function({ commit },data){
        return new Promise((resolve, reject) =>{
            api.call(config.getAPIRoute('back.abonados.abono.invitaciones.guardar-datos-comprador'), data).then(res =>{
                resolve(res);
            }).catch(error =>{
                console.log(error);
                reject(error);
            });
        })
    }
}

export default {
    actions,
};
